import axios from "axios";
import { getCookie } from "../../getcookie";
const apiUrl = process.env.REACT_APP_API_URL;
const apiAdminUrl = process.env.REACT_APP_ADMIN_API_URL;

const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};
// Generate Transport Report
export const transportReportApi = async (body) => {
  try {
    const response = await axios.post(apiUrl + "report", body, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error generating report:", err);
    return err.response;
  }
};

// Save Template
export const saveTemplateApi = async (body) => {
  try {
    const response = await axios.post(apiUrl + "report/template", body, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error saving template:", err);
    return err.response;
  }
};

// Get Templates (Autocomplete)
export const getTemplatesApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + "report/template/autocomplete", {
      params: params,
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching templates:", err);
    return err.response;
  }
};

// Get Template by ID
export const getTemplateByIdApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + "report/template/" + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching template details:", err);
    return err.response;
  }
};

// Get Report Types
export const getReportTypesApi = async () => {
  try {
    const response = await axios.get(apiUrl + "report/type", {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching report types:", err);
    return err.response;
  }
};
//Download base64 file
export const downloadBase64File = (base64String, fileName) => {
  try {
    const base64Data = base64String.replace(/^data:.*,/, "");
    const binary = atob(base64Data);
    const array = [];

    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }

    const blob = new Blob([new Uint8Array(array)], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};
//getQuickreport
export const getquickreportApi = async () => {
  try {
    const response = await axios.get(apiUrl + `get_quick_report`, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const exportquickApi = async (apivalue, formattedFromDate, formattedToDate, expected_date) => {
  try {
    const response = await axios
      .get(apiUrl + apivalue, {
        params: {
          from_date: formattedFromDate,
          to_date: formattedToDate,
          expected_date: expected_date,
        },
        headers: header,
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("error...", error.response);
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
 